import styled from '@emotion/styled';

export default styled('div')`
  margin-top: 3px;
  opacity: .8;
  font-size: .75rem;
`;
